//import ReactDOM from "react-dom";
import './index.css';

//import * as serviceWorker from "./serviceWorker";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import App from './App';
import { I18nextProvider } from 'react-i18next';
import React from 'react';
import { createRoot } from 'react-dom/client';
import i18n from './i18n';
// Import FluentProvider, make @fluentui/react-components works correctly
import { FluentProvider } from '@fluentui/react-components';
import { getRuntimeVariant, Variant } from './SharedCommon/variant';
import getTheme from './SharedCommon/getTheme';

const container = document.getElementById('root');
console.log('index.tsx loaded');
const root = createRoot(container!);

const theme = getTheme();
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n} defaultNS={'translation'}>
      <FluentProvider theme={theme}>
        <App />
      </FluentProvider>
    </I18nextProvider>
  </React.StrictMode>
);

//we'll support pwa only if path/host is pwa, to not confuse others things under the same domain
const forPwa = window.location.hostname.startsWith('pwa') || window.location.pathname.startsWith('/pwa');
if (forPwa) {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}

document.addEventListener('DOMContentLoaded', () => {
  if (getRuntimeVariant() === Variant.fishmeet) {
    document.title = 'FishMeet';

    const metaDesc = document.querySelector('meta[name="description"]');
    metaDesc!.setAttribute('content', 'FishMeet - A social platform for jisti');

    const faviconLinkIcon = document.querySelector('link[rel="icon"]');
    const iconPath = faviconLinkIcon?.getAttribute('href');
    const iconRaw = iconPath!.split('/');

    iconRaw.pop();
    iconRaw.push('favicon-fishmeet.ico');
    faviconLinkIcon!.setAttribute('href', iconRaw.join('/'));
  }
});
